export default {
  theme: () => import(/* webpackChunkName: "bb-themeWrap" */'./ThemeImporter'),
};
